module.exports = __webpack_public_path__ + "media/src/public/images/background-7a37934de38087b83f641e3d68097fed.svg";